import { Component, Inject, OnDestroy } from '@angular/core';
import { SubscriptionsManager } from '../../helpers/subscriptions-manager';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
})
export class ConfirmationModalComponent implements OnDestroy {
  public confirmButtonText = 'Confirm';
  public cancelButtonText = 'Cancel';
  private subsManager = new SubscriptionsManager();
  constructor(
    public dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.confirmButtonText) {
      this.confirmButtonText = data.confirmButtonText;
    }
    if (data.cancelButtonText) {
      this.cancelButtonText = data.cancelButtonText;
    }
  }

  ngOnDestroy(): void {
    this.subsManager.unsubscribeAll();
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
